module.exports = __webpack_public_path__ + "static/fonts/NeoSansPro-LightItalic.a688c54.eot";